import { loginUser } from '@store/reducers/auth';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { Links } from '../../helpers/Links';
import { casService } from '../../helpers/login';
import * as AuthService from '../../services/auth';
import { removeMenu } from '../../store/reducers/menu';
import './login.css';
import LoadingOverlay from 'react-loading-overlay-ts';
import CountDown from './CountDown';
import { ThongBaoTrangLogin } from '../../models/home/Home';
import { layDanhSachThongBaoTaiTrangLogin, layCauHinhSinhNhatQuy } from '../../services/home';
import Marquee from 'react-fast-marquee';
import React from 'react';

const Login = () => {
    const [isAuthLoading, setAuthLoading] = useState(false);
    const [dsThongBao, setDsThongBao] = useState<Array<ThongBaoTrangLogin>>([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [t] = useTranslation();
    const [noiDungNoti, setNoiDungNoti] = useState<number>(0);
    const [stateSinhNhat, setStateSinhNhat] = useState<boolean>(false);

    const login = async (userName: string, passWord: string) => {
        try {
            setAuthLoading(true);
            const info = await AuthService.loginByAuth(userName, passWord);
            toast.success('Đăng nhập thành công!');
            setAuthLoading(false);
            dispatch(loginUser(info));
            navigate('/');
        }
        catch (error: any) {
            setAuthLoading(false);
            dispatch(removeMenu());
            toast.error('Tên đăng nhập hoặc mật khẩu không đúng');
        }
    };

    const loginSSO = () => {
        casService.loginSSO(Links.CasService.CasClient);
    }

    const { handleChange, values, handleSubmit, touched, errors } = useFormik({
        initialValues: {
            userName: '',
            passWord: ''
        },
        validationSchema: Yup.object({
            userName: Yup.string().required('Bắt buộc'),
            passWord: Yup.string().required('Bắt buộc')
        }),
        onSubmit: (values) => {
            login(values.userName, values.passWord);
        }
    });

    const layDSThongBao = async () => {
        let rs = await layDanhSachThongBaoTaiTrangLogin();
        var cauHinh = await layCauHinhSinhNhatQuy();
        setStateSinhNhat(cauHinh == 1 ? true : false);
        setDsThongBao(rs);
    }

    useEffect(() => {
        layDSThongBao();
    }, []);

    return (
        <>
            <div className="marquee-login-text-container">
                <Marquee pauseOnHover gradient={false} speed={40}>
                    <strong>
                        {dsThongBao?.length === 1
                            ? dsThongBao[0].noiDung
                            : (
                                <>
                                    {dsThongBao?.map((item, index) => (
                                        <React.Fragment key={index}>
                                            [{index + 1}]-{item.noiDung}
                                            {index < dsThongBao.length - 1 && <span style={{ marginRight: "20px" }} />}
                                        </React.Fragment>
                                    ))}
                                    <span style={{marginRight: "300px"}} />
                                </>
                            )}
                    </strong>
                </Marquee>
            </div>
            <LoadingOverlay
                active={isAuthLoading}
                spinner={true}
                text="Đang tải..."
            >
                <div className="container-login focus" style={{ maxWidth: "100%" }}>
                    <span className="big-circle"></span>
                    <div className="form-login">
                        <div className="contact-info">
                            <img src="/img/logo-text-ddif.png" style={{ marginBottom: "25px", width: "90%" }} />
                            <br />
                            <h3 className="title-contact-info">Hệ thống quản lý nhân sự</h3>
                            <div className="info">
                                <div className="information-login">
                                    <img src="img/location.png" className="icon-login" alt="" />
                                    <i className="fa-solid fa-map-location" />
                                    <a href="https://maps.app.goo.gl/vkpE4vCrjHwTeHSC9" target="_blank">
                                        <span className="no-wrap-text-login">Số 18 Yên Bái, phường Hải Châu, thành phố Đà Nẵng</span>
                                    </a>
                                </div>
                                <div className="information-login">
                                    <img src="img/email.png" className="icon-login" alt="" />
                                    <span>ddif@danang.gov.vn </span>
                                </div>
                                <div className="information-login">
                                    <img src="img/phone.png" className="icon-login" alt="" />
                                    <span>0236.3.888.769</span>
                                </div>
                                {stateSinhNhat &&
                                    <div className="information-login">
                                        <img src="img/cake.png" className="icon-login" alt="" />
                                        <CountDown />
                                    </div>
                                }
                                <div className="information-login">
                                    <i className="icon-login fa fa-globe" style={{ fontSize: "27px" }} aria-hidden="true"></i>
                                    <a style={{ color: "white" }} href="https://www.ddif.com.vn/" target="_blank">
                                        https://www.ddif.com.vn/
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="contact-form">
                            <span className="circle one"></span>
                            <span className="circle two"></span>
                            <form onSubmit={handleSubmit} id="form-submit-login">
                                <h3 className="title-login a-login">Đăng nhập</h3>
                                <div className="mb-3">
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            id="userName"
                                            name="userName"
                                            type="text"
                                            placeholder="Tài khoản"
                                            onChange={handleChange}
                                            value={values.userName}
                                            isValid={touched.userName && !errors.userName}
                                            isInvalid={touched.userName && !!errors.userName}
                                        />
                                        {touched.userName && errors.userName ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.userName}
                                            </Form.Control.Feedback>
                                        ) : (
                                            <InputGroup.Append>
                                                <InputGroup.Text>
                                                    <i className="fa fa-user" />
                                                </InputGroup.Text>
                                            </InputGroup.Append>
                                        )}
                                    </InputGroup>
                                </div>
                                <div className="mb-5">
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            id="passWord"
                                            name="passWord"
                                            type="password"
                                            placeholder="Mật khẩu"
                                            onChange={handleChange}
                                            value={values.passWord}
                                            isValid={touched.passWord && !errors.passWord}
                                            isInvalid={touched.passWord && !!errors.passWord}
                                        />
                                        {touched.passWord && errors.passWord ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.passWord}
                                            </Form.Control.Feedback>
                                        ) : (
                                            <InputGroup.Append>
                                                <InputGroup.Text>
                                                    <i className="fas fa-lock" />
                                                </InputGroup.Text>
                                            </InputGroup.Append>
                                        )}
                                    </InputGroup>
                                </div>
                                <div className='text-center'>
                                    <button className="btn btn-sm btn-login" type="submit" style={{ width: "210px", height: "48px" }}>
                                        Đăng nhập
                                    </button>
                                    <div className="text-right">
                                        <p style={{ textAlign: "right" }}></p>
                                        <a className="a-login" href="forgot-password">Quên mật khẩu</a>
                                    </div>
                                    {/*<div className='my-5' style={{ width: "100%", borderTop: "1px solid #dee2e6", height: "1px", position: "relative" }}>*/}
                                    {/*    <p className='px-1' style={{ transform: "translateY(-13px)", background: "white", color: "#B0B0B0 ", display: "inline-block" }}>Hoặc</p>*/}
                                    {/*</div>*/}
                                    {/*<button onClick={loginSSO} className="btn btn-sm btn-login" style={{ width: "250px", height: "48px" }} >*/}
                                    {/*    <span className="button__text">*/}
                                    {/*        <img height="30" src="/img/logoegov-sso.png" className="profile-image2" style={{ paddingRight: "5px" }} />*/}
                                    {/*    </span>*/}
                                    {/*    Đăng nhập SSO*/}
                                    {/*</button>*/}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </LoadingOverlay>
        </>
    );
};

export default Login;
